import { useState, useEffect } from 'react';
import { C, t } from '../Dashboard/components/dashboardConstants';
import TalentContentContainer from '../layout/TalentContentContainer';
import ProfileCard from './components/ProfileCard';
import ProfileStats from './components/ProfileStats';
import BioSection from './components/BioSection';
import PortfolioSection from './components/PortfolioSection';
import FilmographySection from './components/FilmographySection';
import BasicInfoCard from './components/BasicInfoCard';
import { getMyTalentProfile, getTalentSkills } from '../../../api';
import LoadingSpinner from '../../../shared/components/LoadingSpinner';
import { useAuth } from '../../../contexts/AuthContext';

export default function TalentProfilePage() {
  const { profileId, userName } = useAuth();
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [skills, setSkills] = useState([]);
  const [skillsLoading, setSkillsLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    // 인증된 내 프로필 조회 (/api/talent/me) — 공개 API 사용 시 profileId 불일치로 남의 것이 뜰 수 있음
    getMyTalentProfile()
      .then(data => {
        setProfile(data);
        const initial = (data.skills || []).map(s => s.name || s.skillName || s).filter(Boolean);
        setSkills(initial);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  async function handleFetchSkills() {
    const pid = profile?.id ?? profileId;
    if (!pid || skillsLoading) return;
    setSkillsLoading(true);
    try {
      const res = await getTalentSkills(pid);
      console.log('[Skills API response]', res);
      const names = res.map(s => s.name || s.skillName || s).filter(Boolean);
      setSkills(names);
    } catch (e) {
      console.error('[Skills API error]', e);
    } finally {
      setSkillsLoading(false);
    }
  }

  return (
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
      <TalentContentContainer>
        {/* Header */}
        <div style={{ padding: '50px 40px 40px', background: C.bg, display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <h1 style={{ ...t('36px', 600, C.bk), margin: 0 }}>나의 포트폴리오</h1>
          <p style={{ ...t('16px', 400, C.sub), margin: 0 }}>
            {userName ? `안녕하세요, ${userName}님. ` : ''}오늘도 좋은 기회가 기다리고 있어요.
          </p>
        </div>

        {/* Content */}
        <div style={{ padding: '0 40px 60px', flex: 1 }}>
          {loading ? (
            <div style={{ padding: '60px 0', display: 'flex', justifyContent: 'center' }}>
              <LoadingSpinner size="md" />
            </div>
          ) : (
            <>
              <ProfileCard profile={profile} />
              <ProfileStats />

              <div style={{ display: 'flex', gap: '32px', marginTop: '40px', alignItems: 'flex-start' }}>
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '32px', minWidth: 0 }}>
                  <BioSection bio={profile?.bio} />
                  <PortfolioSection medias={profile?.medias} profileId={profileId} />
                  <FilmographySection works={profile?.works} medias={profile?.medias} />
                </div>
                <div style={{ width: '320px', flexShrink: 0 }}>
                  <BasicInfoCard
                    profile={profile}
                    skills={skills}
                    onFetchSkills={handleFetchSkills}
                    skillsLoading={skillsLoading}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      </TalentContentContainer>
    </div>
  );
}
